import React from "react";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { useDispatch } from "react-redux";
import { NEInputLight as NEInput } from "../../../components/NEInput";
import CloseIcon from "@material-ui/icons/Close";
import ConfirmDialog from "../../../components/ConfirmDialog";
import request from "../../../shared/lib/request";
import { openSnackBar } from "../../Root/actions";
import {
  getTicketTypesList,
  setCustomerSupportLoader,
} from "../actions";

export default function AddTicketTypeDialog({
  classes,
  isOpen,
  closeAddDialog,
}: any) {
  const dispatch = useDispatch();
  const [isCloseAlertOpen, showAlertToClose] = React.useState(false);
  const [error, setError] = React.useState({
    title: "",
    emailID: "",
  });
  const [emailID, setEmail] = React.useState("");
  const [title, setTitle] = React.useState("");

  const handleEmailChange = (event: any) => {
    setEmail(event.target.value);
  };

  const handleTitleChange = (event: any) => {
    setTitle(event.target.value);
  };

  const onHandleSubmit = (event: any) => {
    let e = { title: "", emailID: "" };
    setError(e);

    let updateData = {
      title: title,
      emailID: emailID,
    };

    if (!title) {
      e.title = "Title is required";
      setError(e);
    } else if (!emailID) {
      e.emailID = "Email ID is required";
      setError(e);
    } else {
      saveTicketType(updateData);
    }
  };

  const saveTicketType = async (data: any) => {
    try {
      dispatch(setCustomerSupportLoader(true));

      await request({
        url: `/admin/v1/create-ticket-type`,
        method: "POST",
        data: data,
      });

      dispatch(setCustomerSupportLoader(false));
      closeAddDialog();
      dispatch(getTicketTypesList());
    } catch (error: any) {
      dispatch(setCustomerSupportLoader(false));
      dispatch(openSnackBar((error && error.data && (error.data.error || error.data.message)) || 'Error saving data'));
    }
  };

  return (
    <div>
      <React.Fragment>
        <Drawer
          anchor={"right"}
          open={isOpen}
          onClose={() => showAlertToClose(true)}
        >
          <ConfirmDialog
            isOpen={isCloseAlertOpen}
            headerText="Are you sure?"
            bodyText="You are about to close the ticket type."
            onAgree={closeAddDialog}
            handleClose={() => showAlertToClose(false)}
            onDisagree={() => showAlertToClose(false)}
          ></ConfirmDialog>

          <div className={classes.rightContainer}>
            <div className={classes.titleDiv}>
              <div className={classes.title}>ADD TICKET TYPE</div>
              <Button
                onClick={() => showAlertToClose(true)}
                className={classes.closeBtn}
              >
                <CloseIcon />
              </Button>
            </div>
            <Divider className={classes.divider} />
            <div className={classes.titleWrapper}>
              <NEInput
                id="ticketTypeTitle"
                name="title"
                label="Title"
                defaultValue={title}
                onChange={handleTitleChange}
                fullWidth
                variant="outlined"
                error={!!error.title}
                helperText={error.title}
                required
              />
            </div>
            <div className={classes.secondRow}>
              <NEInput
                id="Email"
                name="emailID"
                label="Email"
                value={emailID}
                defaultValue={emailID}
                onChange={handleEmailChange}
                fullWidth
                variant="outlined"
                error={!!error.emailID}
                helperText={error.emailID}
                required
              />
            </div>
            <Grid>
              <div className={classes.btnContainer}>
                <Button
                  onClick={(event) => {
                    onHandleSubmit(event);
                  }}
                  className={classes.newbtn}
                  disableRipple={true}
                >
                  <div className={classes.saveLegalBtn}>SAVE</div>
                </Button>
              </div>
            </Grid>
          </div>
        </Drawer>
      </React.Fragment>
    </div>
  );
}
